"use strict";

exports.__esModule = true;
exports.useAlertDetailsController = useAlertDetailsController;
var _react = _interopRequireWildcard(require("react"));
var _AlertsContext = require("../AlertsContext");
var _RestAPI = require("../../API/RestAPI");
var _System = require("../../../System");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function useAlertDetailsController(props) {
  var _React$useContext = _react["default"].useContext(_AlertsContext.AlertsContext),
    getAlertDetails = _React$useContext.getAlertDetails,
    createAlertComment = _React$useContext.createAlertComment,
    patchAlert = _React$useContext.patchAlert;
  var _useState = (0, _react.useState)(false),
    updateAlert = _useState[0],
    setUpdateAlert = _useState[1];
  var alertId = props.alertId,
    onClose = props.onClose,
    refreshData = props.refreshData,
    _props$isFullScreen = props.isFullScreen,
    isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen,
    history = props.history;
  function refreshAlertData() {
    if (refreshData) {
      refreshData();
    } else {
      setUpdateAlert(!updateAlert);
    }
  }
  function handleCreateComment(_x) {
    return _handleCreateComment.apply(this, arguments);
  }
  function _handleCreateComment() {
    _handleCreateComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(comment) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return createAlertComment(alertId, comment);
          case 1:
            setUpdateAlert(!updateAlert);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleCreateComment.apply(this, arguments);
  }
  function handleAcknowledged(_x2) {
    return _handleAcknowledged.apply(this, arguments);
  }
  function _handleAcknowledged() {
    _handleAcknowledged = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(acknowledged) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            patchAlert(alertId, {
              acknowledged: acknowledged
            }).then(function () {
              return refreshData();
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _handleAcknowledged.apply(this, arguments);
  }
  function handleClose() {
    if (isFullScreen) {
      history.push((0, _System.getScreenURL)("AlertList"));
    } else if (onClose) {
      onClose();
    } else {
      console.error("onClose function is not provided");
    }
  }
  var alertRequest = _react["default"].useCallback(function getDetailsCallback() {
    return getAlertDetails(alertId);
  }, [alertId, updateAlert]);
  // This is fetched every time alertRequest is updated

  var requests = _react["default"].useMemo(function requestList() {
    return [alertRequest];
  }, [alertRequest]);
  var _useRequestPromiseLoa = (0, _RestAPI.useRequestPromiseLoader)({
      requests: requests
    }),
    isLoading = _useRequestPromiseLoa.loading,
    data = _useRequestPromiseLoa.data,
    error = _useRequestPromiseLoa.error;
  return {
    isLoading: isLoading,
    data: data,
    error: error,
    handleCreateComment: handleCreateComment,
    handleClose: handleClose,
    refreshAlertData: refreshAlertData,
    handleAcknowledged: handleAcknowledged
  };
}